import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { applyTemplateAction } from 'Shared/actions/workspaces';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';

function BlankWorkspaceTemplateBlock() {
  const dispatch = useDispatch();

  const workspaceId = useSelector(state => state.workspace.id);

  const handleSubmit = useCallback(async () => {
    await dispatch(applyTemplateAction({ workspaceId }));
  }, [dispatch, workspaceId]);

  return (
    <WpContainer onClick={handleSubmit}>
      <WpContainerBody padding={'05'}>
        <div className="WorkspaceTemplateBlock__title my-2">Blank Template</div>
        <div className="WorkspaceTemplateBlock__description mb-2">Start from scratch.</div>
      </WpContainerBody>
    </WpContainer>
  );
}

export default BlankWorkspaceTemplateBlock;
